import { TextField, alpha, outlinedInputClasses, styled } from '@mui/material';

export const TextfieldStyled = styled(TextField)(({ theme }) => ({
  background: theme.palette.background.paper,
  [`& .${outlinedInputClasses.root}`]: {
    [`& .${outlinedInputClasses.notchedOutline}`]: {
      transition: theme.transitions.create(['box-shadow']),
    },
    [`&:hover .${outlinedInputClasses.notchedOutline}`]: {
      borderColor: theme.palette.text.primary,
      boxShadow: `0px 3px 12px  ${alpha(theme.palette.text.primary, 0.25)}`,
    },
    [`&.${outlinedInputClasses.focused} .${outlinedInputClasses.notchedOutline}`]: {
      borderColor: 'rgba(0, 0, 0, 0.23)',
      borderWidth: 1,
    },
  },
}));
